import React from 'react';
import ConditionType from './condition-type';
import {
  BooleanConditionValueSelector,
  DropdownConditionValueSelector,
  RadioConditionValueSelector
} from './value-selectors';
import ConditionFieldSelector from './condition-field-selector';

export default class FieldCondition extends React.Component {

  constructor(props) {
    super(props);
    const model = props.model || {};
    this.state = {
      model: model,
      leftField: (model.left || {}).value ? this.findLeftField(model.left.value) : null,
    };
  }

  findLeftField(id) {
    return this.props.fields.find(f => f.id === id);
  }

  updateLeft(left) {
    this.setState(
      {leftField: null}, // Forcing re-render
      () => this.setState(
        prevState => ({
          model: {...prevState.model, left: left, type: null, right: null},
          leftField: this.findLeftField(left.value),
        }),
        () => this.props.onChange(this.state.model)
      )
    );
  }

  updateType(type) {
    this.setState(
      prevState => ({model: {...prevState.model, type: type, right: null}}),
      () => this.props.onChange(this.state.model)
    );
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = {...prevState.model};
        model[fieldName] = value;
        return {model: model};
      },
      () => this.props.onChange(this.state.model)
    );
  }

  valueSelector(leftField) {
    if (leftField.fieldType === 'CHECKBOX') {
      return <BooleanConditionValueSelector model={this.state.model.right}
                                            onChange={v => this.updateModel('right', v)}/>;
    } else if (leftField.fieldType === 'RADIO' ) {
      return <RadioConditionValueSelector radioGroupFields={this.props.fields.filter(f => f.fieldType === 'RADIO' && f.groupName === leftField.groupName)}
                                          model={this.state.model.right}
                                          onChange={v => this.updateModel('right', v)}/>;
    } else {
      return <DropdownConditionValueSelector fieldConfig={leftField}
                                             value={this.state.model.right}
                                             onChange={v => this.updateModel('right', v)}/>;
    }
  }

  render() {
    return <div>
      <Name value={this.state.model.name || ''}
            onChange={v => this.updateModel('name', v)}/>
      <div className="row align-items-center">
        <div className="col-auto">
          Display when
        </div>
        <div className="col">
          <ConditionFieldSelector fields={this.props.fields}
                                  model={this.state.model.left}
                                  onChange={v => this.updateLeft(v)}/>
        </div>
        <div className="col-auto">
          {this.state.leftField &&
          <ConditionType leftFieldType={this.state.leftField.fieldType}
                         value={this.state.model.type}
                         onChange={v => this.updateType(v)}/>
          }
        </div>
        <div className="col">
          {this.state.leftField && (this.state.model.type || '') === '=' &&
          this.valueSelector(this.state.leftField)
          }
        </div>
      </div>

    </div>
  }

}

class Name extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  render() {
    return <div className="mb-3">
      <label htmlFor="conditionName" className="form-label">Name</label>
      <input type="text"
             id="conditionName"
             className="form-control"
             value={this.state.value || ''}
             onChange={e => this.setState(
               {value: e.target.value},
               () => this.props.onChange(this.state.value)
             )}/>
      <div className="form-text">Helps you identify this condition (does not appear on your store page)</div>
    </div>;
  }
}
